import type { SortOptionProps } from 'components/search/Sort';

export const filterSortOptions = (sortOptions: SortOptionProps[], isBestForYouSortEligible: boolean = false) =>
  sortOptions.filter(({ label }) => label !== 'Best For You' || (label === 'Best For You' && isBestForYouSortEligible));
